module.exports = __webpack_public_path__ + "img/mots-desc.20c42d4e.png";